export const ENTRA_ID_INITIALIZATION_STARTED = 'ENTRA_ID_INITIALIZATION_STARTED';
export const ENTRA_ID_AUTHENTICATED = 'ENTRA_ID_AUTHENTICATED';
export const ENTRA_ID_REAUTHENTICATION_REQUIRED = 'ENTRA_ID_REAUTHENTICATION_REQUIRED';
export const ENTRA_ID_REDIRECT_STARTED = 'ENTRA_ID_REDIRECT_STARTED';
export const ENTRA_ID_AUTH_FAILED = 'ENTRA_ID_AUTH_FAILED';
export const ENTRA_ID_CONFIGURATION_FAILED = 'ENTRA_ID_CONFIGURATION_FAILED';
export const ENTRA_ID_ACCESS_TOKEN_EXPIRES_AT_UPDATED = 'ENTRA_ID_ACCESS_TOKEN_EXPIRES_AT_UPDATED';

export const entraIdInitializationStarted = () => ({ type: ENTRA_ID_INITIALIZATION_STARTED });
export const entraIdAuthenticated = () => ({ type: ENTRA_ID_AUTHENTICATED });
export const entraIdReauthenticationRequired = () => ({ type: ENTRA_ID_REAUTHENTICATION_REQUIRED });
export const entraIdRedirectStarted = () => ({ type: ENTRA_ID_REDIRECT_STARTED });
export const entraIdAuthFailed = () => ({ type: ENTRA_ID_AUTH_FAILED });
export const entraIdConfigurationFailed = () => ({ type: ENTRA_ID_CONFIGURATION_FAILED });
export const entraIdAccessTokenExpiresAtUpdated = (expiresAt?: number) => ({
    type: ENTRA_ID_ACCESS_TOKEN_EXPIRES_AT_UPDATED,
    expiresAt,
});
